module.exports = __webpack_public_path__ + "img/sodam_img03.5146941a.jpg";